import React from 'react';
import {
  OperationMembersFilter,
  OperationMembersHistory,
  OperationPrevMember,
} from '../../../../services/types/Member';
import Table, { Cell } from '../../../../shared/components/Table';
import { customDateStr } from '../../../../shared/misc/utils';
import { TablePagination } from '../../../../shared/components';

interface Props {
  historyContent: OperationMembersHistory;
  filter: OperationMembersFilter;
  changeSort: (field: string, sortDesc: boolean) => void;
  changePage: (value: number) => void;
  changePageSize: (value: number) => void;
}

const HistoryTable: React.FC<Props> = (props) => {
  const { historyContent, filter, changeSort, changePage, changePageSize } = props;
  const { list } = historyContent;

  const cells: Cell<OperationPrevMember>[] = [
    {
      name: 'fullName',
      column: 'userName',
      value: (x) => x.fullName,
      css: 'accent w-25',
    },
    {
      name: 'primary',
      column: 'primary',
      value: (x) => (x.primary ? 'Yes' : 'No'),
    },
    {
      name: 'fromDate',
      column: 'startDate',
      value: (x) => customDateStr(x.fromDate),
    },
    {
      name: 'toDate',
      column: 'endDate',
      value: (x) => customDateStr(x.toDate),
    },
    {
      name: 'rationale',
      column: 'rationale',
      value: (x) => x.rationale,
      css: 'w-40',
    },
  ];

  return (
    <>
      <Table
        data={list}
        cells={cells}
        keyFunc={(x) => x.id}
        sortData={filter}
        changeSort={changeSort}
        emptyNoDesc
        // wrapperClass="my-3"
      />
      <TablePagination
        pageSize={filter.pageSize}
        pageNumber={filter.pageNumber}
        total={historyContent.total}
        onChangePage={changePage}
        onChangeSize={changePageSize}
      />
    </>
  );
};

export default HistoryTable;
